// extracted by mini-css-extract-plugin
export default {"App":"App_App__KJ8Wo","hw":"App_hw__kB67e","hwTitle":"App_hwTitle__joYCs"};